import RadioGroups from "./index.vue";

const svgIconPlugin: any = {
  name: "RadioGroups",
  install(app: any): void {
    app.component("RadioGroups", RadioGroups);
  }
};

export default svgIconPlugin;
